import Vue from "vue"
import Photoswipe from "vue-pswipe"
import VueAnalytics from "vue-analytics"
import localisation from "./localisation/en-GB.json"
import App from "./App"
import router from "./router"
import "./registerServiceWorker"
import "./styles/bm-custom.css"

Vue.config.productionTip = false
Vue.use(Photoswipe)

Vue.mixin({
  data() {
    return {
      loc: localisation,
    }
  },
})

Vue.use(VueAnalytics, {
  id: "UA-145071964-1",
  checkDuplicatedScript: true,
  router,
})

new Vue({
  router,
  render: h => h(App),
}).$mount("#app")
